import { render } from "./CoBrandGlass.vue?vue&type=template&id=19d33885&scoped=true"
import script from "./CoBrandGlass.vue?vue&type=script&lang=js"
export * from "./CoBrandGlass.vue?vue&type=script&lang=js"

import "./CoBrandGlass.vue?vue&type=style&index=0&id=19d33885&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d33885"]])

export default __exports__